function initSizeChart() {
  if (!window.location.pathname.includes('/products/')) {
    return
  }



  const sizeChartButtons = document.querySelectorAll('[data-size-chart-button]')
  const sizeChartModal = document.getElementById('size-chart-modal')
  const closeButtons = document.querySelectorAll('[data-modal-close]')

  // Store the element that had focus before modal opened
  let previousActiveElement = null

  function openModal() {
    // Store the current focused element
    previousActiveElement = document.activeElement

    // Show the modal
    sizeChartModal.showModal()

    // Set focus to the first close button in the modal
    const closeButton = sizeChartModal.querySelector('[data-modal-close]')
    if (closeButton) {
      closeButton.focus()
    }

    // Prevent page scrolling while modal is open
    document.body.style.overflow = 'hidden'
  }

  function closeModal() {
    sizeChartModal.close()

    // Restore focus to the previous element
    if (previousActiveElement) {
      previousActiveElement.focus()
    }

    // Restore page scrolling
    document.body.style.overflow = ''
  }

  function handleEscape(event) {
    if (event.key === 'Escape' && sizeChartModal.open) {
      closeModal()
    }
  }

  // Click outside modal to close
  function handleClickOutside(event) {
    if (event.target === sizeChartModal) {
      closeModal()
    }
  }

  // Add event listeners
  sizeChartButtons.forEach(button => {
    button.addEventListener('click', openModal)
  })

  closeButtons.forEach(button => {
    button.addEventListener('click', closeModal)
  })

  document.addEventListener('keydown', handleEscape)
  sizeChartModal.addEventListener('click', handleClickOutside)
}

// Initialize when DOM is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSizeChart)
} else {
  initSizeChart()
}
